import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { ProviderLogo } from './ui/ProviderLogo';

const formatModel = (modelId) => {
  if (!modelId) return '';
  const parts = modelId.split('/');
  const name = parts[parts.length - 1];
  return name.length > 20 ? name.substring(0, 20) + '…' : name;
};

const formatCost = (cost) => {
  if (cost == null) return '';
  return `$${Number(cost).toFixed(4)}`;
};

const truncate = (str, max) => {
  if (!str) return '';
  return str.length > max ? str.substring(0, max) + '…' : str;
};

const statusDotColor = (status) => {
  const s = String(status).toLowerCase();
  if (s === '200' || s === 'success') return 'bg-green-500';
  if (s === '500' || s === 'error') return 'bg-red-500';
  return 'bg-yellow-500';
};

export const LiveFeed = ({ traces = [] }) => {
  const recent = traces.slice(0, 5);

  return (
    <div className="rounded border border-white/[0.06] bg-[#0a0a0b] p-4 space-y-2">
      <div className="flex items-center gap-2 mb-1">
        <span
          className="inline-block w-1.5 h-1.5 rounded-full bg-green-500"
          style={{ animation: 'pulse 1.5s ease-in-out infinite' }}
        />
        <h3 className="text-[10px] font-semibold text-zinc-400 uppercase tracking-wider font-mono">Live Feed</h3>
        <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }`}</style>
      </div>

      {/* Column headers */}
      <div className="flex items-center gap-3 text-[9px] text-zinc-600 font-mono uppercase tracking-wider border-b border-white/[0.04] pb-1.5">
        <span className="w-2 flex-shrink-0" />
        <span className="w-16 flex-shrink-0">Time</span>
        <span className="w-40 flex-shrink-0">Goal</span>
        <span className="w-36 flex-shrink-0">Model</span>
        <span className="w-16 flex-shrink-0">Cost</span>
        <span>Latency</span>
      </div>

      {recent.length === 0 ? (
        <p className="text-xs italic text-zinc-600 font-mono py-2">Waiting for first trace...</p>
      ) : (
        <div className="space-y-0.5">
          {recent.map((trace) => (
            <div
              key={trace.trace_id}
              className="flex items-center gap-3 text-xs text-zinc-400 font-mono py-1"
            >
              <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${statusDotColor(trace.status)}`} />
              <span className="text-zinc-600 w-16 flex-shrink-0">
                {trace.ts_start
                  ? formatDistanceToNow(new Date(trace.ts_start), { addSuffix: false }).replace('about ', '') + ' ago'
                  : '—'}
              </span>
              <span className="text-zinc-300 truncate w-40 flex-shrink-0">
                {truncate(trace.goal_id || trace.endpoint, 30)}
              </span>
              <span className="text-zinc-500 w-36 flex-shrink-0 flex items-center gap-1.5">
                <ProviderLogo provider={trace.model_id} size={12} />
                {formatModel(trace.model_id)}
              </span>
              <span className="text-zinc-400 w-16 flex-shrink-0">
                {formatCost(trace.total_cost)}
              </span>
              <span className="text-zinc-600">
                {trace.total_duration_ms != null ? `${trace.total_duration_ms}ms` : ''}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
